export const TESTNET_BASE_ASSETS = ['ethereumholesky', 'bitcoinregtest', 'bitcointestnet']

export const defaultEnabledAssetsList = [
  'bsc',
  'basemainnet',
  'matic',
  'tetherusd_solana',
  'solana',
  'ethereum',
  'bitcoin',
  'ethereumarbone',
  'optimism',
  'usdt_optimism_26487766',
  'usdt_ethereumarbone_efa95268',
  'tetherusd',
  'usdcoin',
  'usdc_ethereumarbone_2e1129c4',
  'usdc_optimism_68bb70cd',
  'avalanchec',
  'cardano',
  'fantommainnet',
]

export const defaultEnabledAssetsListForFreshWallets = [
  'ethereumarbone',
  'matic',
  'optimism',
  'polygon',
  'tetherusd_solana',
  'usdt_matic_86e249c1',
  'usdc_matic_0a883d9b',
  'usdcoin_solana',
]
